<main>
    <section>
        <b>
            Endereço:
        </b>
        <span>
            Rua Treze de Maio – 616, CEP 80510-030, Bairro São Francisco, Curitiba - PR
        </span>
    </section>
    <section class="row">
        <div class="mr-2">
            <b>
                Telefone:
            </b>
            <span>
                (41) 3883-6177
            </span>
        </div>
        <div>
            <b>
                E-mail:
            </b>
            <span>
                fundacao@fcopel.org.br
            </span>
        </div>
    </section>
    <div class="data-relatorio-footer">
        Impresso em 19/10/2023 15:55
    </div>
</main>